import { captureAccount } from "./accountStorage";
import axios from "axios";
import { getLocalData } from "./storage";
import { Platform } from "react-native";

import { getApiUrl } from "../utils/urls";

const OPEN_HOUSE_API = getApiUrl();
// Global variable to store the current checkInKey
let currentCheckInKey: string | null = null;

// Function to set the checkInKey
export const setCheckInKey = (checkInKey: string | null) => {
  currentCheckInKey = checkInKey;
};

const openhouseAPI = axios.create({
  baseURL: OPEN_HOUSE_API,
  headers: { "Content-Type": "application/json" },
});

openhouseAPI.interceptors.request.use(
  async (config) => {
    const assertAccount = (config as any).accountGuard || captureAccount();
    assertAccount();
    (config as any).assertAccount = assertAccount;
    let jwt = null;
    await getLocalData("@token").then((token) => {
      jwt = token;
    });

    assertAccount();
    // Allow callers that replay persisted check-ins to bind authorization to
    // the individual request instead of relying on mutable global state.
    if (config.headers["Authorization"]) {
      return config;
    }

    if (currentCheckInKey) {
      config.headers["Authorization"] = `checkInKey ${currentCheckInKey}`;
      return config;
    }

    if (config.url?.includes("auth") || jwt) {
      config.headers["Authorization"] = jwt;
    } else {
      return Promise.reject(new Error("No authentication provided"));
    }

    return config;
  },
  function (error) {
    console.log("error", error);
    return Promise.reject(error);
  }
);

openhouseAPI.interceptors.response.use(
  function (response) {
    (response.config as any).assertAccount?.();
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

export default openhouseAPI;
